










































import Vue from 'vue'

import 'splitpanes/dist/splitpanes.css'

const { Splitpanes, Pane } = require('splitpanes')

interface PaneObject {
  givenSize: number | null
  id: number
  index: number
  max: number
  min: number
  size: number
  minimized: boolean
}

export default Vue.extend({
  name: 'LayoutV1Container',
  components: { Splitpanes, Pane },
  data() {
    return {
      paneSize: 50,
      panels: [] as PaneObject[],
    }
  },
  methods: {
    savePanelsToMemory() {
      localStorage.setItem('vLayoutContainer', JSON.stringify(this.panels))
    },
    loadPanelFromMemory() {
      let panels = localStorage.getItem('vLayoutContainer')
      if (typeof panels != 'string') {
        panels = JSON.stringify([
          { min: 0.00001, max: 50, size: 15 },
          { min: 0.00001, max: 100, size: 85 },
        ])
      }
      this.panels = JSON.parse(panels)
    },
    onSplitterClick(pane: PaneObject) {
      switch (pane.index) {
        case 1:
          this.panels[0].minimized = !this.panels[0].minimized
          break
      }

      const sizePanel0 = this.panels[0].minimized
        ? this.panels[0].min
        : this.panels[0].size

      this.panels[1].size = 100 - sizePanel0

      this.savePanelsToMemory()
    },

    onResized(panels: PaneObject[]) {
      panels.forEach((panel, index) => {
        if (this.panels[index].minimized) return
        this.panels[index].min = panel.min
        this.panels[index].max = panel.max
        this.panels[index].size = panel.size
      })

      this.savePanelsToMemory()
    },
  },

  created() {
    this.loadPanelFromMemory()
  },
})
